import React from 'react';
import classnames from 'classnames';
import DeviationThumbOverlayDefault from '../DeviationThumbOverlayDefault';
import DeviationThumbMiddleContent from '../DeviationThumbMiddleContent';
import ThumbOverlayBackground from '../ThumbOverlayBackground';
import ThumbOverlayHover from '../ThumbOverlayHover';
import s from './Overlay.scss';
const Overlay = ({ deviation , width , height , className , hasCommentedOn , children , isFaved , 'aria-hidden': ariaHidden , extraActions , onRemove  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className),
        style: {
            width,
            height
        },
        "aria-hidden": ariaHidden
    }, /*#__PURE__*/ React.createElement(ThumbOverlayBackground, {
        deviation: deviation,
        className: s['underlay'],
        showDefaultHover: true
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['cover']
    }, /*#__PURE__*/ React.createElement(DeviationThumbOverlayDefault, {
        deviation: deviation,
        width: width,
        height: height,
        isFaved: isFaved,
        hasCommentedOn: hasCommentedOn
    })), /*#__PURE__*/ React.createElement(ThumbOverlayHover, {
        className: s['cover'],
        deviation: deviation,
        width: width,
        height: height,
        extraActions: extraActions,
        onRemove: onRemove
    }), /*#__PURE__*/ React.createElement(DeviationThumbMiddleContent, {
        deviation: deviation,
        thumbWidth: width,
        thumbHeight: height,
        className: s['middle']
    }, children));
};
Overlay.displayName = 'Overlay';
export default Overlay;
